<template>
  <div>
    <div
      class="page-break"
      :key="index"
      v-for="(image, index) in drs.daily_return_sheets_images">
      <img
        class="mr-5"
        :src="image" />
    </div>
  </div>
</template>

<script>
import axios from '../../axios';

export default {
  name: 'DrsPrintPhotos',
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  data() {
    return {
      drs: {
        daily_return_sheets_images: [],
      },
    };
  },
  methods: {
    getDrs() {
      const drsId = this.$route.params.id;
      axios.get(`/dailyReturnSheets/getView/${drsId}.json?token=${this.token}`)
          .then((response) => {
            this.drs = response.data.dailyReturnSheet;
            window.print();
          })
          .catch((error) => {
            console.log(error);
          });
    },
  },
  mounted() {
    this.getDrs();
  },
};
</script>

<style scoped lang="scss">
  .page-break {
    page-break-after: always;
    padding: 20px;
  }
</style>
